"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BHGSelect = void 0;

var _react = _interopRequireDefault(require("react"));

require("./Select.scss");

var BHGSelect = function BHGSelect(props) {
  var type = props.type,
      value = props.value,
      className = props.className,
      error = props.error,
      placeholder = props.placeholder,
      onChange = props.onChange,
      disabled = props.disabled,
      options = props.options;
  return /*#__PURE__*/_react.default.createElement("select", {
    type: type,
    className: "form-control" + (error ? " error " : " ") + (className ? className : ""),
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    disabled: disabled,
    "aria-disabled": disabled
  }, options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: o.value,
      key: o.value
    }, o.label);
  }));
};

exports.BHGSelect = BHGSelect;
BHGSelect.defaultProps = {
  disabled: false,
  value: '',
  error: false,
  placeholder: '',
  options: [],
  onChange: function onChange(e) {
    return console.log(e);
  }
};